// components
import { Navbar1 } from 'components/navbars';
import BackToTop from 'components/BackToTop';
import { Footer1 } from 'components/footer';

import Hero from './Hero';

// dummy data
//import { plans, benefits } from './data';

const NotFound = () => {
    return (
        <>
            <div>
                <Navbar1
                    hideSearch
                    fixedWidth
                    navClass="navbar-light zindex-10"
                    buttonClass="btn-outline-secondary btn-sm"
                />
                <Hero />
            </div>
            <div className="m-auto" style={{display:"block",width: "80%",maxWidth:1200,paddingTop:20}}>
                <p style={{textAlign:"center"}}><strong>The page you're looking for could not be found.</strong></p>
            </div>
            {/* footer */}
            <Footer1 />

            <BackToTop />
        </>
    );
};

export default NotFound;
